import { gql } from 'graphql-request';
import {
  AssetFieldFilterOptions,
  AssetPaginationWindow,
} from '@elementary/common-ui/services/gql/types';
import { CatalogTableAssetResponseItem } from './types';

export const getCatalogTableAssetsQuery = gql`
  query GetCatalogTableAssetsPaged(
    $assetIds: [String!]
    $search: String
    $assetFilters: [Filter!]
    $sort: AssetFieldPaginationSort
    $cursor: String
    $limit: Int!
  ) {
    assetsPaged(
      filters: { ids: $assetIds, search: $search }
      assetFilters: $assetFilters
      sort: $sort
      cursor: $cursor
      limit: $limit
    ) {
      items {
        id
        type
        displayType
        artifactType
        description
        tags
        name
        path
        owners
        subscribers
        isCritical
        ... on TableAsset {
          configPath
          dbName
          schemaName
          tableName
          materialization
          lastDataModificationTime
          latestExecution {
            id
            status
            executionTimestamp
          }
          latestTestExecutions {
            test {
              name
            }
            execution {
              status
              subType
              executionTimestamp
            }
          }
          tableUsage {
            periodStart
            periodEnd
            queriesCount
            uniqueUserCount
            usagePercentile
          }
        }
      }
      pageInfo {
        hasNextPage
        nextCursor
      }
    }
  }
`;

export const getCatalogAssetsFilterOptionsQuery = gql`
  query GetCatalogAssetsFilterOptions($filters: AssetsFilters) {
    assetsFilterOptions(filters: $filters) {
      field
      options {
        value
        count
      }
    }
  }
`;

export type CatalogTableAssetPagedResponse = {
  assetsPaged: {
    items: CatalogTableAssetResponseItem[];
    pageInfo: AssetPaginationWindow['pageInfo'];
  };
};

export type CatalogAssetsFilterOptionsResponse = {
  assetsFilterOptions: AssetFieldFilterOptions[];
};
